import { AnalyticsBrowser } from '@segment/analytics-next'
import React from 'react'

const AnalyticsContext = React.createContext<AnalyticsBrowser | undefined>(
  undefined,
)

type Props = {
  writeKey?: string
  children: React.ReactNode
}
export const AnalyticsProvider = ({ children, writeKey }: Props) => {
  const analytics = React.useMemo(
    () => (writeKey ? AnalyticsBrowser.load({ writeKey }) : undefined),
    [writeKey],
  )
  return (
    <AnalyticsContext.Provider value={analytics}>
      {children}
    </AnalyticsContext.Provider>
  )
}

// Create an analytics hook that we can use with other components.
export const useAnalytics = () => {
  const result = React.useContext(AnalyticsContext)
  if (!result) {
    console.warn('Segment not loaded!')
  }
  return result
}

export default AnalyticsProvider
